import { Upload, UserRound, LayoutDashboard } from 'lucide-react';

export const productTourSteps = [
  {
    number: '01',
    eyebrow: 'Adding people',
    title: 'Upload a CSV or a single resume.',
    mobileTitle: 'Import your roster',
    mobileDescription: 'Bulk CSV or one resume — details filled in automatically.',
    description:
      'On the imports screen you can bulk-upload your roster as a CSV, or drop in one resume. Stavyn reads it and adds the person with their name, role, salary, and hire date filled in for you.',
    highlights: ['Bulk CSV upload', 'AI resume parsing', 'Auto-filled employee records'],
    Icon: Upload,
    image: '/product/add-employee.png',
    imageLight: '/product/add-employee-light.png',
    width: 1024,
    height: 706,
    heightLight: 707,
    alt: 'Stavyn import screen with CSV upload and AI resume upload for adding a new employee.',
    label: 'stavyn.app / imports',
  },
  {
    number: '02',
    eyebrow: 'Employee profile',
    title: 'See one person’s full risk picture.',
    mobileTitle: 'Full risk picture per person',
    mobileDescription: 'Score, pay vs. market, replacement cost, and live role demand.',
    description:
      'Each profile shows the flight-risk score and the signals behind it: pay vs. the market, replacement cost, and the risk trend, alongside how the role is moving in the live job market.',
    highlights: ['Flight-risk score', 'Pay vs. market', 'Replacement cost & trend'],
    Icon: UserRound,
    image: '/product/employee-profile.png',
    imageLight: '/product/employee-profile-light.png',
    width: 1024,
    height: 581,
    heightLight: 579,
    alt: 'Stavyn employee profile for Christopher Williams showing a 83 risk score, key signals, and market comparison.',
    label: 'stavyn.app / people / christopher-williams',
  },
  {
    number: '03',
    eyebrow: 'Dashboard',
    title: 'Watch the whole company at a glance.',
    mobileTitle: 'Whole company at a glance',
    mobileDescription: 'At-risk count, open actions, trend, and top priorities.',
    description:
      'The overview tracks people at risk of leaving, actions in progress, and average risk, plots the retention trend over time, and ranks your highest-risk people so you can act fast.',
    highlights: ['People at risk', 'Actions in progress', 'Retention trend & rankings'],
    Icon: LayoutDashboard,
    image: '/product/dashboard.png',
    imageLight: '/product/dashboard-light.png',
    width: 1024,
    height: 604,
    alt: 'Stavyn dashboard showing company-wide turnover risk, retention trend chart, and highest-risk people.',
    label: 'stavyn.app / dashboard',
  },
];

export function stableStepHeight(step) {
  return Math.max(step.height, step.heightLight ?? step.height);
}
